import { Dispatch } from "react";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { UserHomeBaseService } from "Bands/services";
import { USER_ACTIONS, IUserHomeBasePatchData } from "Bands/types";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys } from "shared/types";
import { IStoreState } from "App/types";

export const dispatchGetUserHomeBases = (dispatch: Dispatch<any>, userId?: string) => {
  dispatch(
    getUserHomeBases({
      userId,
      page: 1,
      paginationKey: USER_ACTIONS.getUserHomeBases,
    })
  );
};

const getUserHomeBases = createAsyncThunk(
  USER_ACTIONS.getUserHomeBases,
  async (
    { userId }: { userId?: string; page: number; paginationKey: string },
    { getState, rejectWithValue }
  ) => {
    try {
      const { currentUser } = (getState() as IStoreState).auth;

      const data = await UserHomeBaseService.getUserHomeBases({
        user: API_ENDPOINTS.USER(userId || currentUser?.id || ""),
      });

      return {
        [IDataKeys.userHomeBase]: data.userHomeBase,
        meta: data.meta,
        pagination: data.pagination,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createUserHomeBase = createAsyncThunk(
  USER_ACTIONS.createUserHomeBase,
  async (base: IUserHomeBasePatchData, { rejectWithValue }) => {
    try {
      const data = await UserHomeBaseService.createUserHomeBase(base);
      const id = Object.values(data?.userHomeBase)?.[0]?.attributes?.id;

      return { id, data };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editUserHomeBase = createAsyncThunk(
  USER_ACTIONS.editUserHomeBase,
  async (
    {
      id,
      data,
    }: {
      id: string;
      data: IUserHomeBasePatchData;
    },
    { rejectWithValue }
  ) => {
    try {
      return await UserHomeBaseService.editUserHomeBase(id, data);
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteUserHomeBase = createAsyncThunk(
  USER_ACTIONS.deleteUserHomeBase,
  async (id: string, { rejectWithValue }) => {
    try {
      await UserHomeBaseService.deleteUserHomeBase(id);
      return {
        path: API_ENDPOINTS.USER_HOME_BASE(id),
        dataKey: IDataKeys.userHomeBase,
      };
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
